<p-card header="Credit Card Detail" class="p-fluid p-formgrid p-grid"
  [style]="{'width': '25rem', 'margin-bottom': '2em', 'margin-left': 'auto', 'margin-right': 'auto', 'background-color': '#f8f9fa'}">
  <div class="p-field p-col-12">
    <ngx-stripe-card [options]="cardOptions" [elementsOptions]="elementsOptions" (change)="onChange($event)">
    </ngx-stripe-card>
  </div>
  <div class="p-field p-col-12 payment-error" id="card-error" *ngIf="!useExistingPaymentMethod"></div>

  <div class="p-field p-col-12 payment-error" *ngIf="errorMessage">{{ errorMessage }}</div>

  <div class="p-field p-col-12 p-md-6">
    <button pButton label="Add new card" class="p-button-rounded p-button-success"
      [disabled]="!paymentElementsValid || processing || useExistingPaymentMethod"
      (click)="createPaymentMethod()"></button>
  </div>

  <div class="p-field-checkbox p-col-12" *ngIf="paymentMethods.length > 0">
    <p-checkbox [(ngModel)]="useExistingPaymentMethod" binary="true" inputId="binary">
    </p-checkbox>
    <label for="binary"><strong> **** **** **** {{ paymentMethods[0].last4 }}</strong></label>
  </div>
  <ng-template pTemplate="footer">
    - Total due now <strong>{{dueAmount/100 | currency}}</strong><br>
    - Subscribed to <strong>{{user.standard_subscribe_id? 'Standard' : ''}} {{user.additional_subscribe_id?
      'Additional' : ''}}</strong>
  </ng-template>
</p-card>
<p-progressBar mode="indeterminate" [style]="{'height': '4px'}" [hidden]="!processing"></p-progressBar>
<div class="p-fluid p-grid p-mt-5">
  <div class="p-col-12 p-md-6">
    <p-card header="Standard Plan" subheader="Monthly"
      [style]="{'width': '250px', 'min-height': '300px', 'margin-left': 'auto', 'margin-right': 'auto', 'background-color': '#f8f9fa'}">
      <div class="price-bold">$5.00</div>
      <div>Pay per month for using rev.ai service</div>
      <ng-template pTemplate="footer">
        <div class="p-d-flex p-jc-center">
          <button pButton label="Subscribe" class="p-button-rounded p-button-help" *ngIf="!user.standard_subscribe_id"
            (click)="createSubscription('standard')" [disabled]="processing || !useExistingPaymentMethod"></button>
          <button pButton label="Unsubscribe" class="p-button-rounded p-button-help p-button-outlined"
            *ngIf="user.standard_subscribe_id" (click)="cancelSubscription('standard')"></button>
        </div>
      </ng-template>
    </p-card>
  </div>
  <div class="p-col-12 p-md-6">
    <p-card header="Additional Plan" subheader="Monthly"
      [style]="{'width': '250px', 'min-height': '300px', 'margin-left': 'auto', 'margin-right': 'auto', 'background-color': '#f8f9fa'}">
      <div class="price-bold">$6.00</div>
      <div>Pay per hour for using Streamtext.net service</div>
      <ng-template pTemplate="footer">
        <div class="p-d-flex p-jc-center">
          <button pButton label="Subscribe" class="p-button-rounded p-button-help" *ngIf="!user.additional_subscribe_id"
            (click)="createSubscription('additional')" [disabled]="processing || !useExistingPaymentMethod"></button>
          <button pButton label="Unsubscribe" class="p-button-rounded p-button-help p-button-outlined"
            *ngIf="user.additional_subscribe_id" (click)="cancelSubscription('additional')"></button>
        </div>
      </ng-template>
    </p-card>
  </div>
</div>